import { useSignUpContext } from "@/contexts/SignUpContext";
import useCurrentUser from "@/hooks/useCurrentUser";
import clsx from "clsx";
import { observer } from "mobx-react";
import React, { useCallback, useEffect, useState } from "react";
import { DateOfBirth } from "./DateOfBirth";
import DietaryRequirements from "./DietaryRequirements";

export const AboutYou = observer(
  ({
    dietaryRequirements,
  }: {
    dietaryRequirements: { id: number; title: string; slug: string }[];
  }) => {
    const { currentUser } = useCurrentUser();
    // Determine whether the user has completed all parts of this form
    const [valid, setValid] = useState(false);
    const { setStepCompleted } = useSignUpContext();

    const onValidChange = useCallback((value) => {
      setValid(value);
    }, []);

    useEffect(() => {
      setStepCompleted("onboardingAboutYou", valid);
      if (valid) {
        handleChange();
      }
    }, [valid]);

    // Ensure allDietaryRequirements is populated from static props if it's empty
    useEffect(() => {
      if (
        currentUser &&
        dietaryRequirements?.length > 0 &&
        currentUser.allDietaryRequirements?.length === 0
      ) {
        currentUser.setAllDietaryRequirements(dietaryRequirements);
      }
    }, [currentUser, dietaryRequirements]);

    const handleChange = () => {
      // Save when valid and user exists - dietary requirements can be empty (meaning "None" was selected)
      if (valid && currentUser && currentUser?.dietaryRequirements.length > 0) {
        currentUser.save();
      }
    };

    return (
      <div className={clsx("w-full")}>
        <div className={clsx("my-8")}>
          <h1
            className={clsx("heading-md--spatial")}
            data-posthog="signup-about-you-heading"
          >
            About You
          </h1>
        </div>
        <div className={clsx("space-y-4")}>
          <DateOfBirth onValidChange={onValidChange} />
          <DietaryRequirements
            dietaryRequirements={dietaryRequirements}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
);
